<script setup lang="ts">
useHead({
  title: '404 - Página não encontrada | Strassen',
  meta: [
    { name: 'description', content: 'A página que você está procurando não foi encontrada. Retorne à página inicial ou entre em contato.' },
    { name: 'robots', content: 'noindex, nofollow' },
  ],
})
definePageMeta({ layout: false })
</script>

<template>
  <section class="w-dvw bg-radial from-olive to-olive-dark min-h-screen flex items-center justify-center">
    <div class="container flex flex-col justify-center items-center py-32">
      <h1 class="text-6xl font-bold text-cream mb-4 font-crimson">
        404
      </h1>
      <h2 class="text-2xl font-semibold text-cream mb-4 font-crimson">
        Página não encontrada
      </h2>
      <p class="text-cream-light mb-8 leading-relaxed text-lg max-w-xs text-center">
        Parece que a página que você está procurando não existe ou foi movida.
      </p>

      <NuxtLink v-slot="{ navigate, href }" to="/" custom>
        <Button
          as="a"
          :href
          color="cream"
          label="Voltar ao início"
          @click="navigate"
        />
      </NuxtLink>
    </div>
  </section>
</template>
